export enum ELandingType {
  Unexpected = 'unexpected',
  JoinOtaCian = 'joinOtaCian',
  JoinOtaLegalShort = 'joinOtaLegalShort',
  ActivateInsurance = 'activateInsurance',
}
